import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Accordion, List, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import * as _ from 'lodash';
import shortid from 'shortid';

import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { resetDirty } from 'State/dirtyTracking/actions';
import { DirtyContext } from 'Components/tracked/DirtyContext';
import { clearState } from 'State/actions';

import { SUB_GROUP_ORDERINGS_BY_GROUP } from './Constants';

class NavGroupContainer extends Component {
  static propTypes = {
    resetDirty: PropTypes.func.isRequired,
    clearState: PropTypes.func.isRequired,
    items: PropTypes.array,
    shouldFilter: PropTypes.func,
  };
  static defaultProps = {
    items: [],
    shouldFilter: () => {},
  };
  state = {
    showYesNoConfirm: false,
    navigateToLink: null,
  };

  getSubGroupOrdinal = (groupName, subGroupName) => {
    return _.get(
      SUB_GROUP_ORDERINGS_BY_GROUP,
      [_.toUpper(groupName), _.toUpper(subGroupName)],
      0
    );
  };

  getRenderElements = (getPageLevelDirty, setPageLevelDirty) => {
    let renderElements = [];
    let data = this.props.items;
    data = _.sortBy(data, d =>
      this.getSubGroupOrdinal(d.GroupName, d.SubGroupName)
    );
    const accessInfoSubGroups = _.groupBy(data, 'SubGroupName');

    renderElements.push(
      this.renderItems(accessInfoSubGroups, getPageLevelDirty)
    );

    renderElements.push(
      <YesNoDialog
        key={shortid.generate()}
        isSavePrompt={true}
        showDialog={this.state.showYesNoConfirm}
        yesCallback={() => {
          const url = '/' + this.state.navigateToLink.split('/').slice(-1)[0];
          this.props.clearState();
          this.setState({ showYesNoConfirm: false });
          this.props.history.push(url);
        }}
        noCallback={() => {
          this.setState({ showYesNoConfirm: false });
        }}
      />
    );

    return renderElements;
  };
  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };
  renderItems = (items, getPageLevelDirty) => {
    let accordionElement = [];
    let listElement = [];
    let iterator = 0;
    let output = [];
    const { shouldFilter } = this.props;
    const { activeIndex } = this.state;
    _.forEach(items, (value, key) => {
      if (key && key !== 'null') {
        iterator = iterator + key;
        accordionElement.push(
          <Accordion.Title
            index={iterator}
            active={
              shouldFilter && shouldFilter() ? true : activeIndex === iterator
            }
            onClick={this.handleClick}
            key={shortid.generate()}
          >
            <Icon name="dropdown" />
            <List.Content
              className={classNames({ 'group-header': key !== 'null' })}
            >
              {key}
            </List.Content>
          </Accordion.Title>
        );

        accordionElement.push(
          <Accordion.Content
            active={
              shouldFilter && shouldFilter() ? true : activeIndex === iterator
            }
            key={shortid.generate()}
          >
            {this.renderInner(value, getPageLevelDirty)}
          </Accordion.Content>
        );
      } else {
        listElement.push(
          <List.Item key={shortid.generate()}>
            <List.Content
              className={classNames({ 'group-header': key !== 'null' })}
            >
              {key !== 'null' ? key : ''}
            </List.Content>
            {this.renderInner(value, getPageLevelDirty)}
          </List.Item>
        );
      }
      iterator++;
    });
    listElement.length > 0 &&
      output.push(
        <List link key={shortid.generate()}>
          {listElement}
        </List>
      );
    accordionElement.length > 0 &&
      output.push(
        <Accordion className={'submenu'} key={shortid.generate()}>
          {accordionElement}
        </Accordion>
      );
    return output;
  };

  renderInner = (value, getPageLevelDirty) => {
    let output = [];
    const { history } = this.props;
    value.forEach(item => {
      if (_.has(item, 'PathUrlSegment')) {
        output.push(
          <List link key={shortid.generate()}>
            <Link
              to={item.PathUrlSegment}
              onClick={e => {
                this.props.resetFilter();
                if (getPageLevelDirty()) {
                  e.preventDefault();
                  this.setState({
                    showYesNoConfirm: true,
                    navigateToLink: e.target.href,
                  });
                } else {
                  this.props.clearState();
                }
              }}
              className={classNames('item sidebar-item', {
                active:
                  item.PathUrlSegment &&
                  history.location.pathname === item.PathUrlSegment,
              })}
              role="listitem"
            >
              {item.FunctionName}
            </Link>
          </List>
        );
      }
    });

    return output;
  };

  render() {
    return (
      <DirtyContext.Consumer>
        {({ getPageLevelDirty, setPageLevelDirty }) => {
          return this.getRenderElements(getPageLevelDirty, setPageLevelDirty);
        }}
      </DirtyContext.Consumer>
    );
  }
}

export const NavGroup = withRouter(
  connect(null, { resetDirty, clearState })(NavGroupContainer)
);



// WEBPACK FOOTER //
// ./src/components/app/sidebar/NavGroup.js